<div class="flex-column gap-4">
	<div class="content-container flex-column gap-2" style="z-index: 1;">
		<!--reviewers table-->
		<trustifi-table-c
			class="trustifi-table" style="flex: 0 0 300px; z-index: 5; overflow: auto;"
			[list]="reviewers"
			[headers]="[
				{text:'Reviewer', sortKey:'email'},
				{text:'Change Configuration', sortKey:'allow_change_configuration', tooltip: 'Allow reviewer to change configurations and settings. If disabled, the reviewer may only review and control emails in quarantine'},
				{text:'View Sensitive Content', sortKey:'allow_view_content_dlp', tooltip: 'Allow reviewer to view the content of assets flagged by DLP rules'},
				{text:'View Malicious Content', sortKey:'allow_view_content_malicious', tooltip: 'Allow reviewer to view the content of assets flagged as malicious'},
				{text:'View Rules Content', sortKey:'allow_view_content_rules', tooltip: 'Allow reviewer to view the content of assets flagged by custom rules'},
			]"
			[cellsPrototype]="[
				{textKey: 'email', edit: {modelKey: 'email', placeholder: 'Reviewer email'}},
				{html: 'changeConfigCell'},
				{html: 'viewContentDlpCell'},
				{html: 'viewContentMaliciousCell'},
				{html: 'viewContentRulesCell'},
			]"
			[bulkActions]="{
				enable: true,
				selectBulkActionCb:	selectMultipleReviewerAction,
				initBulkActionsFunction: showReviewerBulkActions,
				showInRed: {enable: true, terms: ['Remove']}
			}"
			[cellActions] = "{
				enable: true,
				selectItemActionCb:	selectReviewerAction,
				initActionsFunction: showReviewerActions,
				showInRed: {enable: true, terms: ['Remove']}
			}"
			(searchFunction)="searchReviewer($event.searchTerm, $event.activeFilters)"
			(confirmEditFunction)="confirmAddReviewer($event.item, $event.isApproved)"
			[options]="{
				itemsNameSingular: 'reviewer',
				defaultSortKey: '-email',
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<!--action cells-->
				<div *ngIf="cellId === 'changeConfigCell'">
					<span [ngStyle]="{color: item.allow_change_configuration || item.isNew ? 'green' : 'red'}">{{item.allow_change_configuration || item.isNew ? 'Enabled' : 'Disabled'}}</span>
				</div>
				<div *ngIf="cellId === 'viewContentDlpCell'">
					<span [ngStyle]="{color: item.allow_view_content_dlp ? 'green' : 'red'}">{{item.allow_view_content_dlp ? 'Enabled' : 'Disabled'}}</span>
				</div>
				<div *ngIf="cellId === 'viewContentMaliciousCell'">
					<span [ngStyle]="{color: item.allow_view_content_malicious ? 'green' : 'red'}">{{item.allow_view_content_malicious ? 'Enabled' : 'Disabled'}}</span>
				</div>
				<div *ngIf="cellId === 'viewContentRulesCell'">
					<span [ngStyle]="{color: item.allow_view_content_rules ? 'green' : 'red'}">{{item.allow_view_content_rules ? 'Enabled' : 'Disabled'}}</span>
				</div>
			</ng-template>
			<div tableButtons>
				<div class="btn-with-dropdown">
					<btn-c (action)="startAddReviewer();"
						   endIcon="far fa-plus"
						   [isDisabled]="addReviewerInProcess">
						Add Reviewer
					</btn-c>
					<app-dropdown-c [isLf]="true">
						<li (click)="openUsersSelection()">
							Add from my users
						</li>
					</app-dropdown-c>
				</div>
			</div>
		</trustifi-table-c>
	</div>

</div>

<users-selection-component
	*ngIf="usersSelectionPopup?.show"
	[data]="usersSelectionPopup"
	[selectedUsers]="selectedUsers"
	(addCb)="addExistUsersToReviewers($event.users)"
	(removeCb)="startRemoveFromUsersSelection($event.users)">
</users-selection-component>

<popup-c *ngIf="reviewerPermissionPopup?.show"
		 head="Modify Permissions"
		 class="bs-enabled"
		 subTitle="Configure permissions for {{reviewerPermissionPopup.reviewerObj.email}}"
		 (closeCb)="reviewerPermissionPopup = null;"
		 size="dynamic">

	<div class="flxClmn gap-4">
		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>Change Configuration</b>
				<span>
					When enabled - the reviewer can manage all Collaboration Protection settings. When disabled - the reviewer will have read-only access to all Collaboration Protection pages.				</span>
				</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="allow_change_configuration"
								 [hideText]="true"
								 [(model)]="reviewerPermissionPopup.reviewerObj.allow_change_configuration"
								 (onChange)="reviewerChangeConfigurationExecute()"></toggle-switch-c>
			</div>
		</div>
		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>View Sensitive Content</b>
				<span>When enabled - the reviewer can view the content of assets flagged by DLP rules.</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="allow_view_content_dlp"
								 [hideText]="true"
								 [(model)]="reviewerPermissionPopup.reviewerObj.allow_view_content_dlp"
								 (onChange)="reviewerViewContentDlpExecute()"></toggle-switch-c>
			</div>
		</div>
		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>View Malicious Content</b>
				<span>When enabled - the reviewer can view the content of assets flagged as malicious.</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="allow_view_content_malicious"
								 [hideText]="true"
								 [(model)]="reviewerPermissionPopup.reviewerObj.allow_view_content_malicious"
								 (onChange)="reviewerViewContentMaliciousExecute()"></toggle-switch-c>
			</div>
		</div>
		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>View Rules Content</b>
				<span>When enabled - the reviewer can view the content of assets flagged by custom rules.</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="allow_view_content_rules"
								 [hideText]="true"
								 [(model)]="reviewerPermissionPopup.reviewerObj.allow_view_content_rules"
								 (onChange)="reviewerViewContentRulesExecute()"></toggle-switch-c>
			</div>
		</div>
	</div>
</popup-c>
